import { EditOutlined, EyeOutlined, MessageOutlined } from '@ant-design/icons';
import { faCheck, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Flex, Space, Tooltip } from 'antd';
import { Link } from 'react-router-dom';

import {
  U_ACTION,
  U_BALANCE,
  U_COUNT_VISITS,
  U_DATE_VISIT_FIRST,
  U_DATE_VISIT_LAST,
  U_KEY,
  U_LOYALTY_CARD,
  U_MONEY_SPENT,
  U_NAME,
  U_PHONE,
  U_TASK,
  U_VISIT_FREQUENCY,
} from '@app/constants';
import type { NClients } from '@app/types';
import { divideAmount } from '@app/utils';

export const adaptDataToTable = (
  data: NClients.ModelClientLite[],
  handleEdit: (id: number) => void,
  hasUserRightToCommunicate: boolean
) => {
  return data.map((client: NClients.ModelClientLite) => {
    const {
      Id,
      Name,
      Phone1,
      MoneySpent,
      CountVisits,
      DateVisitFirst,
      DateVisitLast,
      Balance,
      VisitFrequency,
      LeadId,
      HasOpenTasks,
      IsLoyaltyCard,
    } = client;

    const transformDate = (utcDate: string) => {
      const date = new Date(utcDate);
      const formattedDate = date.toLocaleString('ru-RU', {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
      });
      return formattedDate;
    };

    return {
      [U_KEY]: String(Id),
      [U_NAME]: (
        <Link
          to={`/leads/card?leadId=${LeadId}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {Name}
        </Link>
      ),
      [U_PHONE]: Phone1?.includes('*') ? Phone1 : `+${Phone1}`,
      [U_BALANCE]: divideAmount(Balance),
      [U_MONEY_SPENT]: divideAmount(MoneySpent),
      [U_COUNT_VISITS]: CountVisits,
      [U_DATE_VISIT_FIRST]: DateVisitFirst ? transformDate(DateVisitFirst) : '',
      [U_DATE_VISIT_LAST]: DateVisitLast ? transformDate(DateVisitLast) : '',
      [U_VISIT_FREQUENCY]: <div>{VisitFrequency ? VisitFrequency : ''}</div>,
      [U_TASK]: (
        <Flex align="center" justify="center">
          <FontAwesomeIcon
            icon={HasOpenTasks ? faCheck : faXmark}
            color={HasOpenTasks ? 'green' : 'red'}
            size={'1x'}
          />
        </Flex>
      ),
      [U_LOYALTY_CARD]: (
        <Flex align="center" justify="center">
          <FontAwesomeIcon
            icon={IsLoyaltyCard ? faCheck : faXmark}
            color={IsLoyaltyCard ? 'green' : 'red'}
            size={'1x'}
          />
        </Flex>
      ),
      [U_ACTION]: (
        <Space>
          <Tooltip title="Редактировать">
            <Button icon={<EditOutlined />} onClick={() => handleEdit(Id)} />
          </Tooltip>

          <Tooltip title="Сообщения">
            <Link
              to={`/leads/card?leadId=${LeadId}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button
                icon={
                  hasUserRightToCommunicate ? (
                    <MessageOutlined />
                  ) : (
                    <EyeOutlined />
                  )
                }
              />
            </Link>
          </Tooltip>
        </Space>
      ),
    };
  });
};
